export const AcceptedStatusCodes = [200, 204, 401, 400];

export const AccessForbiddenCodes = [403];

export const NotFoundCodes = [404];

export const AuthCodes = [401];
